import Axios from "../../Lib/Axios";
export const getService = () => {
    return Axios.get(`service`);
}